/**
 * Peel UI-only top-level keys before building `ImportantContactBodyDtos`: `firstName` / `lastName`
 * map to `name`; `isDependant` / `dependantDetails` are set explicitly on the personal form.
 * Remaining keys already match the API (`telephone`, `lpa`, …) and can be spread onto the payload.
 */
export function peelImportantContactFormFields(
  values: Record<string, unknown>
) {
  const {
    firstName,
    lastName,
    isDependant: _isDependant,
    dependantDetails: _dependantDetails,
    ...rest
  } = values

  return {
    firstName: firstName as string | undefined,
    lastName: lastName as string | undefined,
    rest
  }
}
